import React from 'react';
import { useTranslation } from 'react-i18next';

interface InvoiceStatusBadgeProps {
  status: string;
  /** Optional data-testid for automation */
  'data-testid'?: string;
}

const DEFAULT_STATUS_COLOR = '#e0e0e0';

const statusColors: Record<string, string> = {
  Billed: '#4fc3f7',
  Unsettle: '#ffb74d',
  Unbilled: '#bdbdbd',
  Draft: '#e0e0e0',
  Due: '#fff176',
  Overdue: '#ef5350',
};

const InvoiceStatusBadge: React.FC<InvoiceStatusBadgeProps> = ({ status, ...rest }) => {
  const { t: tBilling } = useTranslation('billing_config');

  return (
    <span
      role="status"
      aria-label={tBilling('invoice.status_badge_aria', { status })}
      data-testid={rest['data-testid'] ?? `invoice-statusBadge-${status.toLowerCase()}`}
      style={{
        background: statusColors[status] ?? DEFAULT_STATUS_COLOR,
        borderRadius: 8,
        padding: '2px 8px',
        fontSize: 12,
        color: '#333',
        marginRight: 4,
      }}
    >
      {status}
    </span>
  );
};

export default InvoiceStatusBadge;
